import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
import { LucideIcon } from "lucide-react";
import { ComponentProps } from "react";
interface IconProps extends ComponentProps<LucideIcon> {
  icon: LucideIcon;
  size?: "sm" | "md" | "lg" | "xl";
  variant?: "default" | "primary" | "secondary" | "muted" | "accent";
}
const sizeClasses = {
  sm: "w-4 h-4",
  md: "w-6 h-6",
  lg: "w-8 h-8",
  xl: "w-10 h-10"
};
const variantClasses = {
  default: "text-gray-900 dark:text-gray-100",
  primary: "text-primary",
  secondary: "text-secondary",
  muted: "text-muted-foreground",
  accent: "text-accent"
};
export function Icon(t0) {
  const $ = _c(14);
  let Icon;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      icon: Icon,
      size: t1,
      variant: t2,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = Icon;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    Icon = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const size = t1 === undefined ? "md" : t1;
  const variant = t2 === undefined ? "default" : t2;
  const t3 = sizeClasses[size];
  const t4 = variantClasses[variant];
  let t5;
  if ($[6] !== className || $[7] !== t3 || $[8] !== t4) {
    t5 = cn(t3, t4, className);
    $[6] = className;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== Icon || $[11] !== props || $[12] !== t5) {
    t6 = <Icon className={t5} {...props} />;
    $[10] = Icon;
    $[11] = props;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}